export const API_URL = 'https://geraniumpos.com:8080/api'
